import * as actionTypes from "../actions/actionTypes";

const initialState = {
  token: null,
  userProfile: null,
  provider: null,
  error: null,
  playerLoaded: false,
  loading: false,
  isUserProfileLoading: false,
  signUpFlow: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.USER_ACTIONS.PLAYER_LOADED:
      return {
        ...state,
        ...{
          playerLoaded: true
        }
      };
    case actionTypes.SET_TOKEN:
      return {
        ...state,
        ...{
          token: action.token || state.token || false,
          provider: action.provider
        }
      };
    case actionTypes.AUTH_LOGOUT:
      return {
        ...state,
        ...{
          token: null,
          userProfile: null,
          provider: null
        }
      };
    case actionTypes.USER_ACTIONS.USER_PROFILE._START:
      return {
        ...state,
        isUserProfileLoading: true
      };

    case actionTypes.USER_ACTIONS.USER_PROFILE._SUCCESS:
      return {
        ...state,
        userProfile: action.payload.data || false,
        isUserProfileLoading: false
      };

    case actionTypes.USER_ACTIONS.USER_PROFILE._FAILURE:
      return {
        ...state,
        userProfile: null,
        isUserProfileLoading: false
      };
    case actionTypes.SET_SIGNUP_FLOW:
      return {
        ...state,
        signUpFlow: true
      };
    case actionTypes.RESET_SIGNUP_FLOW:
      return {
        ...state,
        signUpFlow: false
      };
    default:
      return state;
  }
}
